module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/90.52619234.png";